/**
 * A little plugin that adds value using allow-incomplete attr only if user types something (need to combine back-end and front-end matches validation).
 **/

export default function maskLengthValidation(node) {
	if (node.props.type === 'mask') {
		const isRequired = node?.props?.parsedRules?.some(
			(rule) => rule.name === "required"
		);
		if (node?.props?.mask?.length && !isRequired) {
			document.addEventListener('input', (ev) => {
				if (ev.target.id === node.props.id) {
					if (!node.props.allowIncomplete) {
						node.props.allowIncomplete = true;
					}
				}
			})
		}
	}
}
